import { computed, inject, Injectable, signal } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { JsonWebTokenPayload } from '@dvm-monorepo/interfaces/auth';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private readonly oidcSecurityService = inject(OidcSecurityService);

    public readonly isAuthenticating = signal(false);
    public readonly isAuthenticated = computed(() => this.oidcSecurityService.authenticated().isAuthenticated);

    public readonly user = computed(() => this.oidcSecurityService.userData().userData as JsonWebTokenPayload);
}
